import { z } from "zod";

export const SocialLinkTypeSchema = z
  .enum([
    "instagram",
    "spotify",
    "bandcamp",
    "facebook",
    "twitter",
    "youtube",
    "soundcloud",
    "tiktok",
    "wikipedia",
    "website",
    "other",
  ])
  .or(z.string());

export const SocialLinkSchema = z.object({
  url: z.string(),
  type: SocialLinkTypeSchema,
});
